module.exports = __webpack_public_path__ + "static/media/api.d41d8cd9.bin";